function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".faqa{fill:#797979;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-389.148 -9900.509)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(397.385 9904.274)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  className: "faqa",
  d: "M429.5,9945.812a.745.745,0,0,1-.739.749h-.057a.745.745,0,0,1-.739-.749v-.037a.745.745,0,0,1,.739-.749h.057a.745.745,0,0,1,.739.749Z",
  transform: "translate(-426.039 -9937.132)"
}), /*#__PURE__*/React.createElement("path", {
  className: "faqa",
  d: "M425.374,9919.257a12.9,12.9,0,0,0-1.064,1.15,1.331,1.331,0,0,0-.264.452c-.08.214-.03.512-.142.721a.689.689,0,0,1-.915.287.907.907,0,0,1-.455-1.009,2.077,2.077,0,0,1,.333-1.071,5.116,5.116,0,0,1,.854-1.023c.523-.534,1.31-1.467.458-2.114a1.24,1.24,0,0,0-1.969.732c-.092.4-.225.75-.626.882a.7.7,0,0,1-.806-.228c-.492-.673.141-1.879.639-2.375a2.858,2.858,0,0,1,4.518.786l-.036-.091.036.092.034.087-.034-.086A2.634,2.634,0,0,1,425.374,9919.257Z",
  transform: "translate(-420.6 -9914.886)"
}))), /*#__PURE__*/React.createElement("path", {
  className: "faqa",
  d: "M394.14,9921.059a.788.788,0,0,1-.786-.781l-.014-2.809h-1.815a2.381,2.381,0,0,1-2.378-2.378v-12.2a2.381,2.381,0,0,1,2.378-2.378H408.77a2.381,2.381,0,0,1,2.378,2.378v12.2a2.381,2.381,0,0,1-2.378,2.378H399.7l-5.12,3.455A.781.781,0,0,1,394.14,9921.059Zm-2.615-18.979a.808.808,0,0,0-.806.807v12.2a.807.807,0,0,0,.806.806h2.6a.786.786,0,0,1,.786.782l.011,2.121,4.1-2.769a.783.783,0,0,1,.439-.135h9.311a.807.807,0,0,0,.806-.806v-12.2a.808.808,0,0,0-.806-.807Z"
}));

var SvgFaq = function SvgFaq(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20.55,
    viewBox: "0 0 22 20.55",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFaq, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/faq.10a50b2b.svg";
export { ForwardRef as ReactComponent };